import Flickity from "flickity";

export function init() {
	const elements = Array.from(document.querySelectorAll(".c-card-carousel"));
	elements.forEach((element) => create(element));
}

function create(element) {
	var options = {
		contain: true,
		cellSelector: ".c-card-carousel__card",
		groupCells: true,
		pageDots: true,
		arrowShape: "M30.7,20.3l-29.3,30l29.3,30 M100.7,50.3H1.4",
	};
	new Flickity(element, options);
}
